"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCqaActivityMock = void 0;
function getCqaActivityMock() {
    return [
        {
            revisionType: "ADD",
            entityType: "procedure",
            revInfo: {
                datetime: "2025-03-28T05:37:01.911Z",
                id: 9,
                username: "unitTester@codametrix.com",
                userUid: "2fcdab19-ad53-4969-9b7a-7aebe7e9da66"
            },
            code: {
                active: true,
                id: 2,
                codeAssessmentId: null,
                original: false,
                code: "23200",
                sequenceNumber: 2,
                entityType: "procedure",
                units: 1,
                transaction: {
                    active: true,
                    id: 1,
                    sequenceNumber: 1,
                    original: true
                }
            },
            activityType: "CQA",
            timestamp: new Date("2025-03-28T05:37:01.911Z")
        },
        {
            revisionType: "ADD",
            entityType: "codeAssessment",
            revInfo: {
                datetime: "2025-03-27T23:04:22.438Z",
                id: 3,
                username: "unitTester@codametrix.com",
                userUid: "2fcdab19-ad53-4969-9b7a-7aebe7e9da66"
            },
            codeAssessment: {
                id: 1,
                assessment: "IDEAL CPT",
                role: "CODABLE",
                parentCode: {
                    active: true,
                    id: 1,
                    codeAssessmentId: 1,
                    original: true,
                    code: "99252",
                    sequenceNumber: 1,
                    entityType: "procedure",
                    units: 1,
                    transaction: {
                        active: true,
                        id: 1,
                        sequenceNumber: 1,
                        original: true
                    }
                }
            },
            activityType: "CQA",
            timestamp: new Date("2025-03-27T23:04:22.438Z")
        },
        {
            revisionType: "ADD",
            entityType: "procedure",
            revInfo: {
                datetime: "2025-03-27T23:03:38.790Z",
                id: 1,
                username: "codametrix",
                userUid: "564359b0-6a64-4d03-919f-4d4d4aabc852"
            },
            code: {
                active: true,
                id: 1,
                codeAssessmentId: null,
                original: true,
                code: "99252",
                sequenceNumber: 1,
                entityType: "procedure",
                units: 1,
                transaction: {
                    active: true,
                    id: 1,
                    sequenceNumber: 1,
                    original: true
                }
            },
            activityType: "CQA",
            timestamp: new Date("2025-03-27T23:03:38.790Z")
        }
    ];
}
exports.getCqaActivityMock = getCqaActivityMock;
//# sourceMappingURL=CQAActivity.js.map